import { axiosInstance } from 'src/config/axiosInstance';

class AccountingService {
  static async fetchAccountingSummary(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_HOST_API}/dailyLedger/accounting/summary/${companyId}`
        );
        return response;
      } catch (error) {
        console.error('Error fetching accounting details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
}

export default AccountingService;
